import React, { PropTypes, Component } from 'react'
import InputRange from 'react-input-range'
import 'react-input-range/lib/css/index.css'
import styled from 'styled-components'
import { Fonts, Colors, Metrics } from '../../Themes'
import { numberWithCommas } from '../../Utils'

const propTypes = {
  max: PropTypes.number,
  min: PropTypes.number,
  title: PropTypes.node,
  unit: PropTypes.string,
  rightUnit: PropTypes.bool,
  step: PropTypes.number,
  handleChange: PropTypes.func,
  maxValue: PropTypes.number,
  minValue: PropTypes.number,
  format: PropTypes.func
}

const Range = styled.div`
  width: ${props => (props.width ? props.width : 'auto')};

  .title {
    ${Fonts.style.Label};
    color: ${Colors.black};
  }

  .values {
    margin: ${Metrics.margins.small} 0;
    ${Fonts.style.Input};
    color: ${Colors.black};
  }

  .input-range {
    width: calc(100% - 8px);
    margin-left: 3px;
  }

  .input-range__track {
    height: 3px;
    border-radius: 8px;
    background: #d8d8d8;
  }

  .input-range__track--active {
    background: ${Colors.primary};
  }

  .input-range__slider {
    border: 1px solid ${Colors.primary};
    background: ${Colors.white};
  }
  .input-range__label-container {
    display: none;
  }
`

const defaultProps = {
  min: 0,
  max: 100,
  step: 1,
  unit: '',
  minValue: 0,
  maxValue: 100
}

class RangePicker extends Component {
  constructor (props) {
    super(props)
    this.state = {
      value: {
        min: props.minValue,
        max: props.maxValue
      }
    }
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange (value) {
    this.setState({ value })
    if (this.props.handleChange) {
      this.props.handleChange(value)
    }
  }

  componentWillReceiveProps (nextProps) {
    if (
      this.props.minValue !== nextProps.minValue ||
      this.props.maxValue !== nextProps.maxValue
    ) {
      this.setState({
        value: {
          min: nextProps.minValue,
          max: nextProps.maxValue
        }
      })
    }
  }

  render () {
    const { min, max, title, unit, rightUnit, step } = this.props

    let maxValueLabel = !rightUnit
      ? `${unit}${numberWithCommas(this.state.value.max)}`
      : `${numberWithCommas(this.state.value.max)}${unit}`

    if (this.state.value.max === max) {
      maxValueLabel += '+'
    }

    const minValueLabel = !rightUnit
      ? `${unit}${numberWithCommas(this.state.value.min)}`
      : `${numberWithCommas(this.state.value.min)}${unit}`

    return (
      <Range {...this.props} className='picker'>
        <span className='title'>{title}</span>
        <div className='values'>
          {minValueLabel} - {maxValueLabel}
        </div>
        <InputRange
          maxValue={max}
          minValue={min}
          step={step}
          value={this.state.value}
          onChange={this.handleChange}
        />
      </Range>
    )
  }
}

RangePicker.propTypes = propTypes
RangePicker.defaultProps = defaultProps

export default RangePicker



// WEBPACK FOOTER //
// ./src/components/RangePicker/index.js